function CodiceFiscaleSocieta(codiceFiscaleSocieta) {
    this.codiceFiscaleSocieta = codiceFiscaleSocieta;
    this.cfReg = /^[0-9]{11}$/;
}

CodiceFiscaleSocieta.prototype.isValid = function () {
    switch (this.codiceFiscaleSocieta.length) {
        case 11:
            if (this.cfReg.test(this.codiceFiscaleSocieta))
                return true;
        case 16:
            return true;
    }

    return false;
}

